import React from "react";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import Home from "./pages/Home";
import OfferPage from "./pages/Offer";
import "./assets/css/style.scss";
import EmailPage from "./pages/Email";
import SinglePage from "./pages/Single";
import TemplatePage from "./pages/Template";
import EmbeddedSinglePage from "./pages/EmbeddedSingle";
import Unsubscribe from "./pages/Unsubscribe";
import BundleOffer from "./pages/BundleOffer";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:id" element={<Home />} />
        <Route path="*" element={<Home />} />
        <Route path="/offer" element={<OfferPage />} />

        <Route path="/email" element={<EmailPage />} />

        <Route path="/unsubscribe/:id" element={<Unsubscribe />} />

        <Route path="/template" element={<TemplatePage />} />

        <Route path="/embedded-single" element={<EmbeddedSinglePage />} />

        <Route path="/single" element={<SinglePage />} />

        <Route path="/bundle-offer/:id" element={<BundleOffer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
